import React from 'react'
import ReactDOM from 'react-dom';
import App from './App.js'
import './index.css'
import { BrowserRouter as Router} from 'react-router-dom'
import { GoogleOAuthProvider } from '@react-oauth/google';
ReactDOM.render(
<Router>
<GoogleOAuthProvider clientId="252289257516-er8t7r1qqse9e0osfgg4hg21s2s8ki4r.apps.googleusercontent.com">
<App />
</GoogleOAuthProvider>
</Router>
,document.getElementById('root'))